import {
  ReadyForPaymentEvent,
  SelectingPartialPaymentEvent,
  SelectingPaymentMethodEvent,
  StartPaymentEvent,
  StartPaymentFailedEvent,
  StartPaymentPayloadCreationFailedEvent,
} from 'components/ordering/checkout/events.js'
import { html, LitElement, TemplateResult } from 'lit'
import { customElement, property } from 'lit/decorators.js'


@customElement('csc-pay-button')
export class CSCPayButton extends LitElement {
  @property({ type: Boolean })
  disabled = false

  override connectedCallback() {
    super.connectedCallback()

    window.addEventListener(ReadyForPaymentEvent.type, this.enablePayButton)
    window.addEventListener(SelectingPaymentMethodEvent.type, this.disablePayButton)
    window.addEventListener(StartPaymentPayloadCreationFailedEvent.type, this.enablePayButton)
    window.addEventListener(StartPaymentFailedEvent.type, this.enablePayButton)
    window.addEventListener(SelectingPartialPaymentEvent.type, this.disablePayButton)
    window.addEventListener('keydown', this.handleEnter.bind(this))
  }

  override disconnectedCallback() {
    super.disconnectedCallback()

    window.removeEventListener(ReadyForPaymentEvent.type, this.enablePayButton)
    window.removeEventListener(SelectingPaymentMethodEvent.type, this.disablePayButton)
    window.removeEventListener(StartPaymentPayloadCreationFailedEvent.type, this.enablePayButton)
    window.removeEventListener(StartPaymentFailedEvent.type, this.enablePayButton)
    window.removeEventListener(SelectingPartialPaymentEvent.type, this.enablePayButton)
    window.removeEventListener('keydown', this.handleEnter.bind(this))
  }

  private disablePayButton = () => {
    this.disabled = true
  }

  private enablePayButton = () => {
    this.disabled = false
  }

  private handleEnter(event: KeyboardEvent): void {
    if (event.key !== 'Enter') {
      return
    }
    if (this.disabled) {
      return
    }
    this.dispatchStartPaymentEvent()
  }

  private dispatchStartPaymentEvent() {
    if (this.disabled) { return }

    this.disablePayButton()
    this.dispatchEvent(new StartPaymentEvent())
  }

  protected override render(): TemplateResult {
    return html`
      <cse-button
        type="button"
        variant="primary"
        ?disabled="${this.disabled}"
        @click=${this.dispatchStartPaymentEvent}
      >
        <slot>Continue & pay order</slot>
      </cse-button>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'csc-pay-button': CSCPayButton,
  }
}
